import {createContext, ReactElement, useContext} from 'react';
import {MessageDescriptor} from '@lingui/core';

import {IProtectedRouteProps, MenuGroupKey} from 'entities/user';

export type IMenuEntry = Omit<IProtectedRouteProps, 'element'>;

export interface INavigation {
    menuItems: IMenuEntry[],
    menuGroups: Record<MenuGroupKey, {title: MessageDescriptor, icon: ReactElement}>,
}

const NavigationContext = createContext<INavigation | null>(null);

export const NavigationProvider = NavigationContext.Provider;

export const useNavigation = (): INavigation => {
    const navigation = useContext(NavigationContext);

    if (!navigation) {
        throw new Error('NavigationProvider не найден выше по дереву');
    }

    return navigation;
};
